module.exports = __webpack_public_path__ + "static/acoustic-cc8eb1b0cacf7b9d36145fe74dbcd051.jpg";